import type { Venue as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * The identifying slice of a venue, for fragments that reference a venue
 * without pulling its full record (event rows, venue rooms). Both fields are
 * nullable on the AppSchema.
 */
export type VenueSummary = {
  id?: number;
  name?: string;
};

export const fromGql = (item: GQLItem): VenueSummary => take<VenueSummary>(item, 'id', 'name');
